<template>
  <hic-dialog title="危急值处理" :visible="visible" @open="open" @close="$emit('update:visible', false)" width="40rem">
    <h3 class="left info">
      <span>
        <span>床位：{{ value?.bedNo }}</span>
        <span class="left-pad">姓名：{{ value?.patientName }}</span>
      </span>
    </h3>
    <h3 class="left info">
      <span>
        <span>检验项目：{{ value?.lisCriticalItem.NAME }}</span>
      </span>
    </h3>
    <h3 class="left info">
      <span>
        危急值：
      </span>
    </h3>
    <h3 class="left info">
      <span>
        <el-tag type="danger" size="small" hit effect="plain">{{ value?.lisCriticalItem.content }}</el-tag>
      </span>
    </h3>
    <h3 class="left info">
      <span>
        处理措施：
      </span>
    </h3>
    <el-input v-model="treatment" type="textarea" rows="6" ref="treatment"></el-input>
 
    <template #footer>
      <el-button type="primary" @click="treat" ref="saveButton">已处理</el-button>
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
    </template>
  </hic-dialog>
</template>
<script>
  import { mapGetters } from "sw-hic";
  import api from "./api";
  export default {
    props: {
      visible: Boolean,
      value: Object,
    },
    data() {
      return {
        treatment: null,
      }
    },
    methods: {
      open() {
        this.$nextTick(() => {
          this.$refs.treatment.focus();
        });
      },
      treat() {
        this.value.lisCriticalItem.treatment = this.treatment;
        api.LisRecord.processWarning(this.value).then((res) => {
          this.$emit("saved", res);
          this.$emit("update:visible", false);
        }).catch((err) => {
          this.$message.error(err.message || err);
        });
      },
    },
  }
</script>